import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import persisted from './persisted/index';
import unpersisted from './unpersisted/index';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    persisted: persisted,
    unpersisted: unpersisted,
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: [
        /* Everything that I actually want to persist */
        'persisted',
      ],
    }),
  ],
});

export default store;
